import { IconButton, IconButtonProps } from '@mui/material';
import { useState } from 'react';

import { tApp, tCommon } from '@frontend/locales';

import { MenuIcon } from '../icons';
import { AppDrawer } from './app-drawer.component';

export interface DrawerActionProps extends IconButtonProps {
  bg?: string;
}

export const DrawerAction = (props: DrawerActionProps) => {
  const [toggleDrawer, setToggleDrawer] = useState(false);

  return (
    <>
      <IconButton
        data-testid="drawer-action"
        onClick={() => setToggleDrawer(!toggleDrawer)}
        size="large"
        aria-label={tApp.drawer.drawerMenu()}
        aria-description={tApp.drawer.description({
          action: toggleDrawer
            ? tCommon.actions.close()
            : tCommon.actions.open(),
        })}
        sx={{
          backgroundColor: props.bg,
          '&:hover': {
            backgroundColor: props.bg,
          },
        }}
        {...props}
      >
        <MenuIcon />
      </IconButton>

      <AppDrawer openState={toggleDrawer} toggleDrawer={setToggleDrawer} />
    </>
  );
};
